import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import CircularProgress from '@mui/material/CircularProgress';

import Button from '@components/Atoms/Button/Button';
import { exportPMOutcomeExcel } from '@apis/reports';
import useExamReportCsvExport from '@components/Component/LearnosityExams/hooks/useExamReportCsvExport';
import { PMBandDef } from './types';

interface PMExportExcelButtonProps {
  districtId: number;
  year: string | null;
  period: string;
  compare: string | null;
  bands: PMBandDef[] | null;
  subject: string;
  view: 'summary' | 'raw' | 'blooms' | 'standards';
  disabled?: boolean;
}

/**
 * Queues one PM Outcomes Excel workbook for the active subject + sub-tab
 * (sheets: District, Schools, Teachers, Sections, Students).
 * Reuses the exam-report download websocket hook; gated by page-level pm_reports access.
 */
const PMExportExcelButton: React.FC<PMExportExcelButtonProps> = ({
  districtId,
  year,
  period,
  compare,
  bands,
  subject,
  view,
  disabled = false,
}) => {
  const { isExporting, startExport } = useExamReportCsvExport('xlsx');

  return (
    <Button
      variant="outlined"
      size="small"
      disabled={disabled || isExporting}
      onClick={() =>
        startExport(() =>
          exportPMOutcomeExcel({
            districtId,
            year,
            period,
            compare,
            bands: bands?.map(({ label, lower }) => ({ label, lower })) ?? null,
            subject,
            view,
          }),
        )
      }
      startIcon={
        isExporting ? <CircularProgress size={16} color="inherit" /> : <DownloadIcon />
      }
    >
      {isExporting ? 'Preparing Excel...' : 'Export Excel'}
    </Button>
  );
};

export default PMExportExcelButton;
